 document.addEventListener("DOMContentLoaded", function() {
      var flagBr = document.querySelector('a.lenguage-flag.br-flag');
      var flagUk = document.querySelector('a.lenguage-flag.uk-flag');
      var arrow = document.querySelector('.lenguage-change .arrow');
      var lenguageChange = document.querySelector('.lenguage-change');



      if (!flagUk && !arrow && !lenguageChange) {
         return;
      }

     // Función que oculta o muestra el selector de lenguaje
      function showHide(e) {
          e.preventDefault();
          e.stopPropagation();
          if (flagBr.style.display == "none" || flagBr.style.display === "") {
              flagBr.style.display = "block";
              lenguageChange.classList.add('open');
          } else if (flagBr.style.display == "block") {
              flagBr.style.display = "none";
              lenguageChange.classList.remove('open');
          }
      }

      // Asigna eventos de clic al botón y a la flecha para mostrar/ocultar
      flagUk.addEventListener("click", showHide, false);
      arrow.addEventListener("click", showHide, false);

      // Cierra el selector de lenguaje al hacer clic en cualquier parte del documento
      document.addEventListener("click", function(e) {
          var clic = e.target;

          // Si se hace clic fuera del selector de lenguaje, se cierra
          if (flagBr.style.display == "block" && clic != flagBr && clic != flagUk && clic != arrow) {
              flagBr.style.display = "none";
              lenguageChange.classList.remove('open');
          }
      }, false);
  });